const alex = "/_app/immutable/assets/alex.IV3YuqVG.png";
export {
  alex as default
};
